/*jshint -W040*/
(function () {
    'use strict';

    angular
        .module('app.region')
        .component('rmapAreaMapDisplay', {
            bindings: {
                map: '<',
                mode: '<',
                model: '<',
                geodata: '<',
                statesWithSites: '<',
                onStateAdded: '&',
                onSiteAdded: '&',
                onSiteRemoved: '&',
                onStateWithSitesAdded: '&',
                onStateWithSitesRemoved: '&'
            },
            templateUrl: 'app/region/dashboard/map/areaDisplay/area.map.display.component.html',
            controller: areaMapDisplayController,
            controllerAs: 'vm'
        });

    /* @ngInject */
    function areaMapDisplayController($scope, leaflet, utilitiesService) {
        this.$onChanges = onChanges;
        this.$onDestroy = onDestroy;

        var vm = this;
        var geoJsonLayer;

        vm.areaSiteModel = [];       

        vm.onStateDeselected = onStateDeselected;
        vm.onSiteSelected = onSiteSelected;
        vm.onSiteDeselected = onSiteDeselected;
        vm.getAllSitesForState = getAllSitesForState;

        function onChanges(changes) {
            if (changes.geodata && changes.geodata.currentValue.features) {
                if (vm.map !== null) {
                    if (geoJsonLayer) {
                        clearFeatureSelections();
                        geoJsonLayer.clearLayers();
                    }
                    geoJsonLayer = leaflet.geoJson(vm.geodata, {
                        style: styleFeature,
                        onEachFeature: onEachFeature
                    }).addTo(vm.map);
                }
            }

            if (changes.model) {
                updateFeatureSelections();
            }
        }

        function onDestroy() {
            clearFeatureSelections();
            geoJsonLayer.clearLayers();
        }

        function onStateDeselected(stateId) {
            geoJsonLayer.eachLayer(function (layer) {
                if (layer.feature.properties.STATEID === stateId) {
                    layer.feature.properties.selected = false;
                    var index = utilitiesService.getIndexOf(vm.model.states, 'id', stateId);
                    vm.onStateWithSitesRemoved({ index: index });
                }
            });
        }

        function onSiteSelected(stateObject) {
            var stateIndex = utilitiesService.getIndexOf(vm.model.states, 'id', stateObject.stateId);
            vm.onSiteAdded({ stateIndex: stateIndex, site: stateObject.site });
        }

        function onSiteDeselected(stateObject) {
            var stateIndex = utilitiesService.getIndexOf(vm.model.states, 'id', stateObject.stateId);
            vm.onSiteRemoved({ stateIndex: stateIndex, siteIndex: stateObject.siteIndex });
        }

        function clearFeatureSelections() {
            geoJsonLayer.eachLayer(function (layer) {
                layer.feature.properties.selected = false;
            });
        }

        function onEachFeature(feature, layer) {
            layer.on('mouseover', function () {
                if (!feature.properties.selected) {
                    setFillColor(layer, true);
                }
            });

            layer.on('mouseout', function () {
                if (!feature.properties.selected) {
                    setFillColor(layer, false);
                }
            });

            layer.on('click', function () {
                if (!feature.properties.selected) {
                    showFeatureMarkers(layer);
                    layer.setStyle({ fillColor: 'green' });
                    feature.properties.selected = !feature.properties.selected;
                } else {
                    removeFeatureMarkers(layer);
                }
                $scope.$apply();
            });
        }

        function updateFeatureSelections() {
            geoJsonLayer.eachLayer(function (layer) {
                layer.feature.properties.selected = false;
                angular.forEach(vm.model.states, function (state) {
                    if (layer.feature.properties.STATEID === state.id) {
                        layer.feature.properties.selected = true;
                    }
                });
            });
            redrawFeatures();
        }

        function getAllSitesForState(stateId) {
            return vm.statesWithSites.filter(function (state) {
                return state.StateId === stateId;
            })[0];
        }

        function redrawFeatures() {
            geoJsonLayer.eachLayer(function (layer) {
                if (!layer.feature.properties.selected) {
                    geoJsonLayer.resetStyle(layer);
                    removeFeatureMarkers(layer);
                } else {
                    layer.setStyle({ fillColor: 'green' });
                }
            });
        }

        function showFeatureMarkers(layer) {
            var sites = [];
            angular.forEach(vm.statesWithSites, function (states) {
                if (states.StateId === layer.feature.properties.STATEID) {
                    angular.forEach(states.Sites, function (site) {
                        var displayName = site.CustomerName.split('-');
                        sites.push({
                            id: site.CustomerId,
                            name: displayName[0],
                            address: displayName[1],
                            city: displayName[2],
                            latitude: site.Latitude,
                            longitude: site.Longitude
                        });
                    });
                }
            });
            var state = {
                id: layer.feature.properties.STATEID,
                name: layer.feature.properties.NAME,
                sites: sites,
                layer: null
            };
            vm.onStateWithSitesAdded({ state: state });
        }

        function removeFeatureMarkers(layer) {
            var index = utilitiesService.getIndexOf(vm.model.states, 'id', layer.feature.properties.STATEID);
            if (index !== -1) {
                if (vm.model.states[index].sites.length === 0) {
                    angular.forEach(vm.model.states, function (state) {
                        if (state.id === layer.feature.properties.STATEID) {
                            vm.onStateWithSitesRemoved({ index: index });
                            layer.setStyle({ fillColor: '#f9f9f9' });
                            layer.feature.properties.selected = !layer.feature.properties.selected;
                        }
                    });
                }
            }
        }

        function styleFeature() {
            return {
                color: '#000',
                weight: 0.5,
                zIndex: 1,
                fillColor: '#f9f9f9',
                fillOpacity: 0.2
            };
        }

        function setFillColor(layer, isMouseOver) {
            if (isMouseOver) {
                layer.setStyle({ fillColor: '#333' });
            } else {
                layer.setStyle({ fillColor: '#f9f9f9' });
            }

        }
    }

})();
